import React from 'react'

import { Html } from '@application/Interfaces/Atoms/Html'
import { Button } from '@application/Interfaces/Molecules/Button'
import { TitleDescriptionType } from '@application/Types/ComponentTypes'
import Container from '@mui/material/Container'

import { Content, Description, Image, ImageWrapper, Link, Title, Wrapper } from './TitleDescription.styled'

export const TitleDescription = (props: TitleDescriptionType): JSX.Element => {
    const { title, description, image, buttonLabel, buttonUrl, mode, imageAnimation } = props

    return (
        <Wrapper $mode={mode}>
            <Container classes={{ root: 'container-wrapper' }}>
                <Content withImage={!!image}>
                    <Title>{title}</Title>
                    <Description>
                        <Html content={description.data.childMarkdownRemark.html as string} />
                    </Description>
                    {buttonLabel && buttonUrl && (
                        <Link to={buttonUrl}>
                            <Button>{buttonLabel}</Button>
                        </Link>
                    )}
                </Content>
                {image && (
                    <ImageWrapper>
                        <Image image={image} imageAnimation={imageAnimation} />
                    </ImageWrapper>
                )}
            </Container>
        </Wrapper>
    )
}
